import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const notifications = {
  unreadCount: () => {
    const url = api.notifications.unreadCount
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  list: params => {
    const url = api.notifications.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  markAsRead: notificationId => {
    const url = api.notifications.markAsRead(notificationId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  markAllAsRead: () => {
    const url = api.notifications.markAllAsRead
    return baseURL.get(url, { headers: getAuthHeader() })
  }
}
export default notifications
// src/constants/api.js